"use client";

import React from "react";
import Image from "next/image";
import { useRouter } from "next/navigation";

import Base from "@/templates/Base";
import Container from "@/components/Container";
import Box from "@/components/shared/Box/box";
import Heading from "@/components/shared/Heading";
import Text from "@/components/shared/Text";
import Button from "@/components/shared/Button";

import s from "./styles.module.scss";

const NotFoundTemplate = () => {
  const router = useRouter();

  return (
    <Base>
      <Container>
        <Box
          borderRadius="var(--token-border-radius-lg)"
          border="1px solid var(--token-colors-neutral-cloud-normal)"
          padding="var(--token-spacings-xs)"
          gap="var(--token-spacings-xs)"
          justifyContent="center"
          alignItems="center"
          className={s.box}
        >
          <Image
            src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/pet-anjo-avatar-404.svg"
            alt="Avatar de ilustração de rota não encontrada"
            width={400}
            height={128}
            className={s.image}
          />
          <div className={s.text}>
            <Heading size="xs" style={{ textAlign: "center" }}>
              Desculpe, não encontramos esta página
            </Heading>
            <div>
              <Text size="md" style={{ textAlign: "center" }}>
                Parece que a página que você está procurando não existe mais.
              </Text>
              <Text size="md" style={{ textAlign: "center" }}>
                Verifique se você digitou o endereço corretamente ou acesse a
                nossa página inicial.
              </Text>
            </div>
          </div>
          <Button size="md" variant="pa-blue" onClick={() => router.push("/")}>
            Voltar para página inicial
          </Button>
        </Box>
      </Container>
    </Base>
  );
};

export default NotFoundTemplate;
